import api from '../../lib/api';
import type {
  DictionaryListParams,
  DictionaryListResult,
  ToggleBookmarkResult,
} from './types';

export const fetchDictionaryTerms = async (
  params: DictionaryListParams = {},
): Promise<DictionaryListResult> => {
  const query: Record<string, string | number> = {};
  if (params.standard && params.standard !== 'all') {
    query.standard = params.standard;
  }
  if (params.q) {
    query.q = params.q;
  }
  if (params.page) {
    query.page = params.page;
  }
  if (params.pageSize) {
    query.pageSize = params.pageSize;
  }

  const { data } = await api.get<DictionaryListResult>('iso-implementation/dictionary', {
    params: query,
  });
  return data;
};

export const toggleDictionaryBookmark = async (termId: string): Promise<ToggleBookmarkResult> => {
  const { data } = await api.put<ToggleBookmarkResult>(
    `iso-implementation/dictionary/bookmarks/${termId}`,
  );
  return data;
};
